module.exports = __webpack_public_path__ + "static/Donate-dbb8326b3c9b6855e2d331d25ad648fd.jpg";